import { createFeatureSelector, createSelector } from '@ngrx/store';

import { JourneysState } from './journey.reducers';

// tslint:disable: max-line-length
export const journeysFeatureStateSelector = createFeatureSelector<JourneysState>('journey');

export const selectJourney = createSelector(journeysFeatureStateSelector, (state: JourneysState) => state.journey);
export const selectJourneyFindParams = createSelector(journeysFeatureStateSelector, (state: JourneysState) => state.findParams);
